(() => {
  const init = () => {
    const header = document.querySelector('.noir-header');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = 'true';
    const toggle = header.querySelector('[data-noir-menu]');
    const nav = header.querySelector('.noir-nav');
    const close = (focus = false) => {
      toggle.setAttribute('aria-expanded', 'false');
      header.classList.remove('noir-menu-open');
      if (focus) toggle.focus();
    };
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      header.classList.toggle('noir-menu-open', open);
      if (open) header.querySelectorAll('details[open]').forEach(el => el.open = false);
    });
    nav.addEventListener('click', event => { if (event.target.closest('a')) close(); });
    document.addEventListener('click', event => { if (!header.contains(event.target)) close(); });
    header.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        if (header.classList.contains('noir-menu-open')) close(true);
        header.querySelectorAll('.noir-languages[open]').forEach(el => { el.open = false; el.querySelector('summary').focus(); });
      }
    });
    header.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      close();
      header.querySelectorAll('details[open]').forEach(other => { if (other !== detail) other.open = false; });
    }));
    document.addEventListener('click', event => header.querySelectorAll('.noir-languages[open]').forEach(detail => { if (!detail.contains(event.target)) detail.open = false; }));
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
